import { render, staticRenderFns } from "./externalAssociate.vue?vue&type=template&id=4ee5489e&scoped=true"
import script from "./externalAssociate?vue&type=script&lang=js&external"
export * from "./externalAssociate?vue&type=script&lang=js&external"
import style0 from "./externalAssociate.vue?vue&type=style&index=0&id=4ee5489e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5489e",
  null
  
)

export default component.exports